import { StyleProvider } from '@ant-design/cssinjs'
import { Render as RenderShell } from '@micun/form'
import {
  GlobalMessage as CompGlobMessage,
  GlobalModal as CompGlobModal,
} from '@micun/web-components'
import '@micun/web-components/dist/assets/index.css'
import ComponentRender from '@micun/web-components/dist/components/Render'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import { GlobalMessage } from 'components/GlobalMessage'
import { GlobalModal } from 'components/GlobalModal'
import { LayoutProvider } from 'components/Layout2'
import Render from 'components/Render'
import 'const'
import 'dayjs/locale/zh-cn'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import './assets/finance.css'
import './assets/index.css'
import Router from './pages/router'
import './react-app-env.d'
import reportWebVitals from './reportWebVitals'
import theme from './theme'

// 创建一个 client
const queryClient = new QueryClient()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <HelmetProvider>
    <LayoutProvider config={{ appCode: 'cbs' }}>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider locale={zhCN} theme={theme}>
          <StyleProvider hashPriority='high'>
            <Router />
            <ComponentRender />
            <Render />
            <RenderShell />
            <GlobalMessage />
            <GlobalModal />
            <CompGlobMessage />
            <CompGlobModal />
          </StyleProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </LayoutProvider>
  </HelmetProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
